<template>
  <v-navigation-drawer
    location="right"
    :model-value="true"
    width="420"
    @update:model-value="(value: boolean) => !value && emit('close')"
  >
    <div class="d-flex justify-space-between align-center pa-4">
      <span class="text-h6 font-weight-bold">{{ sector.sector_name }}</span>
      <v-btn icon="fa-regular fa-xmark" variant="text" @click="emit('close')" />
    </div>

    <v-divider />

    <div class="px-4 py-4">
      <v-row>
        <v-col cols="4">
          <div class="text-caption text-medium-emphasis">
            Emitidos
          </div>
          <div class="text-h6">
            {{ sector.summary.generated }}
          </div>
        </v-col>
        <v-col cols="4">
          <div class="text-caption text-medium-emphasis">
            Computados
          </div>
          <div class="text-h6">
            {{ sector.summary.read }}
          </div>
        </v-col>
        <v-col cols="4">
          <div class="text-caption text-medium-emphasis">
            Taxa de acesso
          </div>
          <div class="text-h6" :class="`text-${accessRateColor(sector.summary.access_rate)}`">
            {{ Math.round(sector.summary.access_rate) }}%
          </div>
        </v-col>
      </v-row>
    </div>

    <v-divider />

    <access-control-block-section title="Pagantes" :block="sector.paying" />

    <v-divider />

    <access-control-block-section title="Não pagantes" :block="sector.non_paying" />
  </v-navigation-drawer>
</template>

<script lang="ts" setup>
import { accessRateColor } from '@/components/TAccessRateGauge.vue'
import type { AccessControlSector } from '@/types/AccessControl'
import AccessControlBlockSection from './access-control-block-section.vue'

interface Props {
  sector: AccessControlSector
}

defineProps<Props>()

const emit = defineEmits<{ close: [] }>()
</script>
